import { cn } from '@/lib/utils';
import type { Sensitivity } from '@/types/gated-resource';

const sensitivityConfig: Record<Sensitivity, { label: string; className: string }> = {
  low:      { label: 'Low',      className: 'bg-muted text-muted-foreground' },
  medium:   { label: 'Medium',   className: 'bg-status-warning/15 text-status-warning' },
  high:     { label: 'High',     className: 'bg-status-warning/25 text-status-warning font-semibold' },
  critical: { label: 'Critical', className: 'bg-status-deny/15 text-status-deny font-semibold' },
};

interface SensitivityBadgeProps {
  sensitivity: Sensitivity;
  className?: string;
}

export function SensitivityBadge({ sensitivity, className }: SensitivityBadgeProps) {
  const config = sensitivity ? sensitivityConfig[sensitivity] : undefined;
  if (!config) return <span className="text-xs text-muted-foreground">—</span>;
  return (
    <span className={cn('inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium', config.className, className)}>
      {config.label}
    </span>
  );
}
